import React from 'react';
import ServicePageTemplate from './ServicePageTemplate';
import { socialMediaMarketingConfig } from './servicePageConfigs';

const SocialMediaMarketing = () => (
  <ServicePageTemplate {...socialMediaMarketingConfig} />
);

export default SocialMediaMarketing;
